import React from "react"
import useTranslations from "hooks/useTranslations"
import DisclosureList from "components/organisms/common/DisclosureList"
import CompassIcon from "images/icon-compass.svg"
import ShieldIcon from "images/icon-shield.svg"
import HelpIcon from "images/icon-help.svg"
import EyeIcon from "images/icon-eye.svg"

const Help = ({ title = "", Image }) => {
  const {
    onboardingFaq1Question,
    onboardingFaq1Answer1,
    onboardingFaq1Answer2,
    onboardingFaq1AnswerList1,
    onboardingFaq1AnswerList2,
    onboardingFaq1AnswerList3,
    onboardingFaq1AnswerList4,
    onboardingFaq1AnswerList5,
    onboardingFaq2Question,
    onboardingFaq2Answer1,
    onboardingFaq2Answer2,
    onboardingFaq3Question,
    onboardingFaq3Answer1,
    onboardingFaq3Answer2,
    onboardingFaq4Question,
    onboardingFaq4Answer1,
    onboardingFaq4Answer2,
    onboardingFaq4Answer3,
  } = useTranslations()
  const list = [
    {
      name: onboardingFaq1Question,
      icon: CompassIcon,
      description: (
        <>
          <p className="mb-0 text-sm">{onboardingFaq1Answer1}</p>
          <ul className="my-4 ml-4 list-disc text-sm">
            <li>{onboardingFaq1AnswerList1}</li>
            <li>{onboardingFaq1AnswerList2}</li>
            <li>{onboardingFaq1AnswerList3}</li>
            <li>{onboardingFaq1AnswerList4}</li>
            <li>{onboardingFaq1AnswerList5}</li>
          </ul>
          <p className="mb-0 text-sm">{onboardingFaq1Answer2}</p>
        </>
      ),
    },
    {
      name: onboardingFaq2Question,
      icon: HelpIcon,
      description: (
        <div className="flex flex-col space-y-2">
          <p className="mb-0 text-sm">{onboardingFaq2Answer1}</p>
          <p className="mb-0 text-sm">{onboardingFaq2Answer2}</p>
        </div>
      ),
    },
    {
      name: onboardingFaq3Question,
      icon: EyeIcon,
      description: (
        <div className="flex flex-col space-y-2">
          <p className="mb-0 text-sm">{onboardingFaq3Answer1}</p>
          <p className="mb-0 text-sm">{onboardingFaq3Answer2}</p>
        </div>
      ),
    },
    {
      name: onboardingFaq4Question,
      icon: ShieldIcon,
      description: (
        <div className="flex flex-col space-y-2">
          <p className="mb-0 text-sm">{onboardingFaq4Answer1}</p>
          <p className="mb-0 text-sm">{onboardingFaq4Answer2}</p>
          <p className="mb-0 text-sm">{onboardingFaq4Answer3}</p>
        </div>
      ),
    },
  ]
  return (
    <DisclosureList
      title={title}
      list={list}
      Image={Image}
      initialActive={0}
      contentClassName="lg:pb-20"
      reversed
      theme="light"
    />
  )
}

export default Help
